
      var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgImageElectricity = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.5 39.5c8.854.325 16.758-6.966 17.104-16.406C38.85 16.382 36.676 11.99 31.5 9M14.315 7.299c-4.97 2.757-8.455 8.203-8.689 14.586-.213 5.808 2.316 11.04 6.356 14.281",
  stroke: "#000",
  strokeWidth: 2.75,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m28.5 5-4.606 11.377a1.069 1.069 0 0 0 1.138 1.46l5.239-.73c.94-.13 1.57.937 1.004 1.697L15.5 40",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 2.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.5 5h-6.875c-.438 0-.831.267-.993.674L14.626 20.79c-.29.73.282 1.514 1.067 1.46l4.495-.308a1.069 1.069 0 0 1 1.083 1.417L15.5 40",
  stroke: "#000",
  strokeWidth: 2.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg width=\"44\" height=\"44\" viewBox=\"0 0 44 44\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M21.5 39.5C30.3536 39.8246 38.2579 32.5344 38.604 23.0937C38.8501 16.382 36.676 11.9907 31.5 9M14.3146 7.29853C9.3452 10.0561 5.86018 15.5017 5.62617 21.8847C5.4132 27.6935 7.94232 32.9252 11.9822 36.1665\" stroke=\"black\" stroke-width=\"2.75\" stroke-linecap=\"round\"/>\r\n<path d=\"M28.5 5L23.8941 16.3772C23.5855 17.1394 24.2174 17.95 25.032 17.8367L30.2708 17.1077C31.2101 16.977 31.8416 18.0435 31.2754 18.8042L15.5 40\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M28.5 5H21.6253C21.1874 5 20.7939 5.26713 20.6322 5.67408L14.6265 20.7897C14.3361 21.5206 14.908 22.3042 15.6927 22.2505L20.1878 21.9425C20.952 21.8902 21.5215 22.6351 21.2706 23.3588L15.5 40\" stroke=\"black\" stroke-width=\"2.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/image-electricity.ae94121d7de4c1abea7f204c25ae60d6.svg"),
        {
          React: SvgImageElectricity,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      